import { Box } from "@mui/material";
import MDTypography from "components/MDTypography";

const legendItems = [
  { color: "#4caf50", label: "Up" },
  // { color: "#ff9800", label: "Warning" },
  { color: "#f44336", label: "Down" },
];

export default function Legend() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
        p: 1,
      }}
    >
      {legendItems.map((item) => (
        <Box
          key={item.label}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <Box
            sx={{
              width: 16,
              height: 16,
              backgroundColor: item.color,
              border: "1px solid #000",
            }}
          />
          <MDTypography variant="body2">{item.label}</MDTypography>
        </Box>
      ))}
    </Box>
  );
}
